var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20127 7.83008H5.24662V13.668H2.64042V7.83008H0.503335V5.43237H2.64042V3.58197C2.64042 1.49701 3.8914 0.324219 5.79392 0.324219C6.70609 0.324219 7.67039 0.506653 7.67039 0.506653V2.56555H6.60185C5.55937 2.56555 5.24662 3.19104 5.24662 3.86865V5.43237H7.56614L7.20127 7.83008Z",
    fill: "#086AD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.4b49bdaa72b3e4bd511d65ff4a35c1d4.svg";
export { ForwardRef as ReactComponent };